import React, {useState, Fragment, useEffect} from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Grid, List, ListItem, ListItemIcon, ListItemText, Stack, Switch, Typography } from '@mui/material';

import MainCard from "../../Components/MainCard";

import { CheckOutlined } from '@ant-design/icons';
import FreeLogo from "../../assets/images/price/Free";
import PremiumLogo from "../../assets/images/price/Premium";
import Animation from "../../sections/landing/Animation";
import {API} from "aws-amplify";
import {useDispatch, useSelector} from 'react-redux';
import useOAuth2 from "../../OAuth2/OAuth2";
import XeroLoginButton from "../../Components/XeroLoginButton";
import {getConnections, handlerSetXeroConnectionsList, handlerSetXeroTenant} from "../../store/reducer/xero_connection";
import {openSnackbar} from "../../store/reducer/snackbar";

const plans = [
    {
        active: false,
        icon: <FreeLogo />,
        title: 'Single Organisation Plan',
        description:
          'Ideal for businesses with only 1 Xero Subscription. Includes 1 user as part of subscription with option to purchase additional user add-ons.',
        price: 4,
        permission: [0, 2, 4, 5]
    },
    {
    active: true,
    icon: <PremiumLogo />,
    title: 'Multi Organisation Plan',
    description:
      'Ideal for accountants, book keepers and businesses with multiple Xero Subscriptions. No limit on number of Xero Organisations connected to the App. Includes 10 users with option to buy additional users in bulk (each add on is per 10 user).',
    price: 10,
    permission: [1, 3, 4, 6]
  }
];

const planList = [
  '1 Xero Organisation Connection', // 0
  'Unlimited Xero Organisation Connections', //1
  '1 User Included', // 2
  '10 Users included', // 3
  'Dashboard Analytics', // 4
  'Purchase User Add-Ons', //5
  'Bulk Purchase User Add Ons' //6
];

const PricingXeroSubscription = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const customer_portal_url = process.env.REACT_APP_XERO_PLAN_PAGE_URL;
    const xero_tenant = useSelector((state) => {
      return state.xeroconnection.xero_tenant
    });
    const[timePeriod, setTimePeriod] = useState(true);
    const checkout_path = process.env.REACT_APP_CHECKOUT_PATH;
    const apiName = process.env.REACT_APP_ENDPOINT_NAME;

    const { data, loading_xero, error, getAuth } = useOAuth2({
        authorizeUrl: "https://login.xero.com/identity/connect/authorize",
        clientId: process.env.REACT_APP_CLIENT_ID,
        // redirectUri: `${document.location.origin}/callback`,
        redirectUri: process.env.REACT_APP_redirectSignIn + `callback`,
          scope: "offline_access openid profile email accounting.invoices accounting.payments accounting.banktransactions accounting.manualjournals accounting.contacts accounting.settings.read accounting.reports.read payroll.employees.read payroll.payruns.read payroll.payslip.read payroll.timesheets.read ",
        responseType: "code",
      });

    useEffect(() => {
        console.log(xero_tenant);
        if (JSON.stringify(xero_tenant)!='{}'){
          // if (!('defaultValue' in data.data)){
              console.log("Got");
              console.log(JSON.parse(JSON.stringify(xero_tenant)));
              const result = JSON.parse(JSON.stringify(xero_tenant));
              console.log(result);
              dispatch(handlerSetXeroTenant({
                xero_tenant:result
              }));
              return function clear_local_storage(){
                  localStorage.removeItem(process.env.REACT_APP_OAUTH_STATE_KEY);
              }
          }
    }, [data]);

    async function checkoutRedirectClick(event){
        console.log(event);
        window.open(customer_portal_url, '_blank');
    }
    const priceListDisable = {
        opacity: 0.4,
        '& >div> svg': {
            fill: theme.palette.secondary.light
    }
    };


    return (
        <>
        {JSON.stringify(xero_tenant)!='{}' &&
    <Grid container alignItems="center" justifyContent="center" spacing={2} sx={{ mt: { md: 0, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
        <Grid item xs={12}>
            <Grid container spacing={1} justifyContent="center" sx={{ mb: 4, textAlign: 'center' }}>
                <Grid item sm={10} md={6}>
                    <Grid container spacing={1} justifyContent="center">
                        <Grid item xs={12}>
                            <Typography variant="h4">
                                Subscription - Early Bird Promotion
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

        <Grid item xs={10}>
            <Animation
              variants={{
                hidden: { opacity: 0, translateY: 550 },
                visible: { opacity: 1, translateY: 0 }
              }}
            >
                <MainCard contentSX={{ p: 3, background: '#f8f9fa'}}>
                    <Grid container spacing={1} justifyContent="center">
                    {/*<Grid container item xs={12} md={9} lg={7}>*/}
                    <Stack spacing={2}>
                      <Stack direction="row" spacing={1.5} alignItems="center">
                        <Typography variant="subtitle1" color={timePeriod ? 'textPrimary' : 'textSecondary'}>
                          Billed Monthly
                        </Typography>
                      </Stack>
                      <Typography color="textSecondary">
                        Choice of 2 plans. The Single Organisation Plan includes 1 user. For additional users please select add-ons during checkout. For best integration and user experience ensure that the user that purchases the subscription is a Xero Admin that can modify permissions in Xero.
                      </Typography>
                    </Stack>
                  </Grid>
                </MainCard>
            </Animation>
      </Grid>
        <Grid item xs={10}>
        <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        >
      <Grid item container spacing={2} xs={10}>

        {plans.map((plan, index) => (
          <Grid item xs={6} sm={5} md={5} key={index} alignItems="center">
            <MainCard sx={{ pt: 1.75 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2} textAlign="center">
                    {plan.icon}
                    <Typography variant="h4">{plan.title}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Typography>{plan.description}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1} alignItems="flex-end">
                    {timePeriod && <Typography variant="h2">${plan.price} Early Bird Promotion</Typography>}
                    {!timePeriod && <Typography variant="h2">${plan.price * 10}</Typography>}
                    {/*<Typography variant="h6" color="textSecondary">*/}
                    {/*  Introductory Offer*/}
                    {/*</Typography>*/}
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Button
                      variant={plan.active ? 'contained' : 'outlined'}
                      fullWidth
                      size="large"
                      onClick={(event) => checkoutRedirectClick(event)}
                  >
                    Order Now
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <List
                    sx={{
                      m: 0,
                      p: 0,
                      '&> li': {
                        px: 0,
                        py: 0.625,
                        '& svg': {
                          fill: theme.palette.success.dark
                        }
                      }
                    }}
                    component="ul"
                  >
                    {planList.map((list, i) => (
                      <Fragment key={i}>
                        <ListItem sx={!plan.permission.includes(i) ? priceListDisable : {}} divider>
                          <ListItemIcon>
                            <CheckOutlined />
                          </ListItemIcon>
                          <ListItemText primary={list} />
                        </ListItem>
                      </Fragment>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </MainCard>
          </Grid>
        ))}

      </Grid>
            </Animation>
            </Grid>
    </Grid>
        }
            {JSON.stringify(xero_tenant)=='{}' &&
            <Grid container alignItems="center" justifyContent="center" spacing={2} sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}>
        <Grid item xs={12}>
        <Grid container spacing={1} justifyContent="center" sx={{ mb: 4, textAlign: 'center' }}>
          <Grid item sm={10} md={6}>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12}>
                <Typography variant="h2">
                  Subscription - Early Bird Promotion
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

        <Grid item xs={10}>
            <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        >
        <MainCard contentSX={{ p: 3, background: '#f8f9fa'}}>
            <Grid container spacing={1}>
            {/*<Grid container item xs={12} md={9} lg={7}>*/}
            <Stack spacing={2}>
              {/*<Stack direction="row" spacing={1.5} alignItems="center">*/}
              {/*  <Typography variant="subtitle1" color={timePeriod ? 'textSecondary' : 'textPrimary'}>*/}
              {/*    Billed Yearly*/}
              {/*  </Typography>*/}
              {/*  <Switch checked={timePeriod} onChange={() => setTimePeriod(!timePeriod)} inputProps={{ 'aria-label': 'container' }} />*/}
              {/*  <Typography variant="subtitle1" color={timePeriod ? 'textPrimary' : 'textSecondary'}>*/}
              {/*    Billed Monthly*/}
              {/*  </Typography>*/}
              {/*</Stack>*/}
              <Typography color="textSecondary">
                Select your subscription plan best suited for your business.
              </Typography>
            </Stack>
          </Grid>
        </MainCard>
            </Animation>
      </Grid>
                <Grid item xs={10}>
        <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        >
      <Grid item container spacing={2}>

        {plans.map((plan, index) => (
          <Grid item xs={10} sm={5} md={5} key={index}>
            <MainCard sx={{ pt: 1.75 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2} textAlign="center">
                    {plan.icon}
                    <Typography variant="h4">{plan.title}</Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Typography>{plan.description}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" spacing={1} alignItems="flex-end">
                    {timePeriod && <Typography variant="h2">${plan.price} Early Bird Promotion</Typography>}
                    {!timePeriod && <Typography variant="h2">${plan.price * 10}</Typography>}
                    {/*<Typography variant="h6" color="textSecondary">*/}
                    {/*  Introductory Offer*/}
                    {/*</Typography>*/}
                  </Stack>
                </Grid>
                {/*<Grid item xs={12}>*/}
                {/*  <XeroLoginButton getAuth={getAuth} />*/}
                {/*</Grid>*/}
                <Grid item xs={12}>
                  <List
                    sx={{
                      m: 0,
                      p: 0,
                      '&> li': {
                        px: 0,
                        py: 0.625,
                        '& svg': {
                          fill: theme.palette.success.dark
                        }
                      }
                    }}
                    component="ul"
                  >
                    {planList.map((list, i) => (
                      <Fragment key={i}>
                        <ListItem sx={!plan.permission.includes(i) ? priceListDisable : {}} divider>
                          <ListItemIcon>
                            <CheckOutlined />
                          </ListItemIcon>
                          <ListItemText primary={list} />
                        </ListItem>
                      </Fragment>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </MainCard>
          </Grid>
        ))}

      </Grid>
            </Animation>
                </Grid>
    </Grid>
            }
        </>
  );
}

export default PricingXeroSubscription;